import { render, staticRenderFns } from "./x-qrcode.vue?vue&type=template&id=39f9506e&"
import script from "./x-qrcode.vue?vue&type=script&lang=js&"
export * from "./x-qrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports